module.exports = __webpack_public_path__ + "static/media/switch.08e04717.mp3";